const validateEmailType    = value => {
  return value.length === 0 || /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/i.test(value)
}

const validatePasswordType = value => {
  return typeof(value) === "undefined" || (typeof(value) === "string" && value.length === 0) || (typeof(value) === "string" && value.length >=7 )
}

const validatePasswordLength = value => {
  return value.length > 7
}

function isRequired(val) {
  // return  typeof(field)==="undefined" ||
  //         field.pristine ||
  console.log(`VALUE IS - ${typeof(val)} -`)
  return  typeof(val)==="undefined" ||
          val.length
}

export {
  validateEmailType,
  validatePasswordLength,
  validatePasswordType,
  isRequired
}



// WEBPACK FOOTER //
// ./src/js/validations/shared_validations.js